import { Box, Drawer, IconButton } from "@mui/material";
import axios from "axios";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { loadAction } from "redux/reducers/top";
import {
  loadEventListAction,
  initEventAction,
} from "redux/reducers/event/index";
import InfiniteScroll from "react-infinite-scroll-component";
import moment from "moment";
import { rem, eventDateFormat, evtDateFormat } from "assets/js/common";
import React, { useEffect, useState, Suspense } from "react";
import { useHistory } from "react-router-dom";
import EventDetailDefault from "./detail/default";
import Comment from "./comment";
import Share from "components/ui/share";
import LazyCDNImage from "components/utils/lazy-cdn-image";
import Loading from "components/ui/loading";
import PullToRefresh from "react-simple-pull-to-refresh";
import Spinner from "components/ui/spinner";
import { Cookies } from "react-cookie";

const useStyles = makeStyles((theme) => ({
  eventList: {
    "& .list-items": {
      padding: rem(30),
      "& .list-item": {
        "& img": {
          borderRadius: rem(10),
          width: "100%",
          height: rem(176),
          objectFit: "cover",
        },
        "& .tit": {
          paddingTop: rem(20),
          fontWeight: 700,
        },
        "& .sub-tit": {
          paddingTop: rem(4),
          fontSize: rem(14),
          color: theme.palette.text.disabled,
        },
        "& .date": {
          paddingTop: rem(4),
          fontSize: rem(14),
          color: theme.palette.text.disabled,
        },
        "& + .list-item": {
          paddingTop: rem(50),
        },
      },
    },
  },
}));

export default function EventList() {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const { schForm, eventList, loading } = useSelector((state) => state.event);

  let cookies = new Cookies();

  let favInfo = cookies.get("favInfo");

  const storeCode = favInfo
    ? favInfo.visibleTp === "1"
      ? favInfo.favMt
      : favInfo.favMk
    : "";

  const [detailData, setDetailData] = useState([]);
  const [selectedSeq, setSelectedSeq] = useState("");
  const [rows, setRows] = useState({
    list: [],
  });

  const [sordFld, setSordFld] = useState("dday");

  const loadDetail = async (seq) => {
    await axios.get(`/api/eh/event-winner/get/${seq}`).then((res) => {
      setDetailData(res.data.data.eventWinner);
    });
  };
  const [detailOpen, setDetailOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerData, setDrawerData] = useState("dday");
  const [initialized, setInitialized] = useState(true);

  const handleInfiniteScroll = () => {
    if (schForm.pg >= rows.totalPageSize) {
      setInitialized(false);
      return;
    }
    dispatch(
      loadEventListAction({
        ...schForm,
        pg: schForm.pg + 1,
        schTp: favInfo && favInfo.visibleTp ? favInfo.visibleTp : 1,
        schEvtYn: "Y"
      })
    );
  };

  useEffect(() => {
    dispatch(loadAction({ back: true, title: "이벤트", menu: true }));
    dispatch(
      loadEventListAction({
        pg: 1,
        pgSz: 10,
        schStore: storeCode ? storeCode : "ALL",
        schTp: favInfo && favInfo.visibleTp ? favInfo.visibleTp : 1,
        schEvtYn: "Y"
      })
    );
  }, []);

  useEffect(() => {
    if (eventList) {
      if (schForm.pg == 1) {
        setRows({ ...eventList });
      } else {
        setRows({ ...eventList, list: [...rows.list, ...eventList.list] });
      }
    }
  }, [eventList]);

  const handleRefresh = () => {
    return new Promise((resolve) => {
      dispatch(
        loadEventListAction({
          pg: 1,
          pgSz: 10,
          schStore: storeCode ? storeCode : "ALL",
          schTp: favInfo && favInfo.visibleTp ? favInfo.visibleTp : 1,
          schEvtYn: "Y"
        })
      );
      resolve(eventList);
    });
  };

  // useEffect(() => {
  //   window.appBackKeyHandle = () => {
  //     if (detailOpen) {
  //       setDetailOpen(false);
  //     } else if (drawerOpen) {
  //       setDrawerOpen(false);
  //     } else {
  //       history.goBack();
  //     }
  //   };
  // }, [detailOpen, drawerOpen]);
  return (
    <>
      <Loading open={loading ? true : false} />
      <PullToRefresh
        onRefresh={handleRefresh}
        pullingContent={false}
        refreshingContent={<Spinner />}
      >
        <div className={"flexItem " + classes.eventList}>
          <ul className="list-items">
            {/* {loading && (
          <li>
            {Array.from(Array(3)).map((_, index) => (
              <>
                <div
                  style={{
                    borderRadius: rem(10),
                    width: "100%",
                    height: rem(176),
                    backgroundColor: "#CCCCCC",
                  }}
                />
                <Box pt={4} pb={10}>
                  <Skeleton height={30} width={200} />
                  <Skeleton height={30} />
                  <Skeleton height={30} width={100} />
                </Box>
              </>
            ))}
          </li>
        )} */}

            {rows.list.length == 0 ? (
              <div className="nodata mt15">
                <Box className="illust">
                  <img
                    src={`${process.env.PUBLIC_URL}/images/icon/nodata.svg`}
                  />
                </Box>
                <p className="color-info">진행중인 이벤트가 없습니다</p>
              </div>
            ) : (
              <InfiniteScroll
                dataLength={rows.list.length}
                next={handleInfiniteScroll}
                hasMore={setInitialized}
                inverse={false}
              >
                {rows.list.map((item, i) => (
                  <li
                    key={i}
                    className="list-item"
                    onClick={() => {
                      setSelectedSeq(item.seq);
                      // dispatch(
                      //   loadEventAction({
                      //     seq: item.seq,
                      //     storeCode: "ALL",
                      //   })
                      // );
                      // setDetailOpen(true);
                      dispatch(
                        initEventAction({
                          seq: item.seq,
                          storeCode: storeCode || "ALL",
                        })
                      );
                      history.push(`/event/${item.seq}`);
                    }}
                  >
                    <span style={{ display: "block", height: "176px" }}>
                      <LazyCDNImage
                        key={i + moment()}
                        cdnUrl={item.repImgUrl}
                        style={{ height: "176px", borderRadius: "10px" }}
                      />
                    </span>
                    <div className="tit">{item.ttl}</div>
                    <div className="sub-tit">{item.desc}</div>
                    <div className="date">
                      {evtDateFormat(item.evtStrtYmd, item.evtEndYmd)}
                    </div>
                  </li>
                ))}
              </InfiniteScroll>
            )}
          </ul>
          <Drawer
            anchor="bottom"
            open={detailOpen}
            onClose={() => {
              setDetailOpen(false);
            }}
            className="drawer-common-bottom size-high event-drawer"
          >
            <div className="drawer-head">
              <h3>진행중인 이벤트</h3>
              <IconButton
                aria-label="close"
                className="btn-close"
                onClick={() => {
                  setDetailOpen(false);
                }}
              >
                <span className="hidden">닫기</span>
              </IconButton>
            </div>

            <div className="drawer-body">
              {/* <EventDetailDefault /> */}
              {/* <Comment /> */}
              {/* <Share /> */}
            </div>
            {/* <div className="drawer-foot">
          <Button color="primary" variant="contained">
            당첨결과 확인하기
          </Button>
        </div> */}
          </Drawer>
        </div>
      </PullToRefresh>
    </>
  );
}
